export default __webpack_public_path__ + "static/media/preciosReg_leedSUME_febENG_v.8cc58dde.png";